module.exports = __webpack_public_path__ + "static/media/21ECLAC24.8f18f2cc.jpg";